export const isNullOrUndefined = (value: any) => {
	return value === null || value === undefined;
};

// Returns `text` unchanged when it contains no tags; otherwise returns the plain-text content.
export const stripHtml = (text: string): string => {
	if (!text || !text.includes('<')) return text;
	const textContent = new DOMParser().parseFromString(text, 'text/html').body.textContent ?? '';
	return textContent.replace(/\s+/g, ' ').trim();
};
